import { Location } from 'generated/models';
import { ComponentProps } from 'components/VirtualizedTable/types';
import LocationStatus from 'components/Locations/LocationStatus';

const StatusCell = ({ row: { status } }: ComponentProps<Location>) => (
  <LocationStatus status={status} />
);

export default StatusCell;
